export const benefits = [
  {
    id: '1',
    iconName: 'moneyBag',
    title: 'O valor que você precisa',
    description: 'Financiamento a partir de R$ 50 mil. Imóvel com valor mínimo de R$ 300 mil.'
  },
  {
    id: '2',
    iconName: 'clock',
    title: 'Prazos mais longos',
    description: 'Até 240 meses (no SAC) e 144 meses (no PRICE) para pagar.'
  },
  {
    id: '3',
    iconName: 'home',
    title: 'Use para obter o imóvel que desejar',
    description: 'Imóveis novos, usados, residenciais e comerciais, com exceção de terrenos e construção.'
  },
  {
    id: '4',
    iconName: 'person',
    title: 'Feito para você',
    description: '  Pessoa Jurídica e Pessoa Física (sem limites de participantes na mesma operação).'
  }
]
